// 1 балл = 1 ₽: суммы показываем в баллах с подписью рублей.
export const formatPoints = (value) =>
  `${Number(value ?? 0).toLocaleString("ru-RU", { maximumFractionDigits: 2 })} ₽`

export const TYPE_LABELS = { 1: "Начисление", 2: "Списание", 3: "Сгорание" }

export const COLORS = {
  accrued: "#3f8600",
  writtenOff: "#cf1322",
  burned: "#d48806",
  debt: "#cf1322",
  forecast: "#8c8c8c",
}

export const formatDate = (value) => (value ? value.slice(0, 16).replace("T", " ") : "—")
